import React, { useState } from 'react';
import { Box, Button, Typography } from '@mui/material';
import { AppLayout } from '../components/layout/AppLayout';
import { AppointmentsList } from '../components/features/AppointmentsList';

type TabValue = 'upcoming' | 'past';

export const AppointmentsPage: React.FC = () => {
  const [tabValue, setTabValue] = useState<TabValue>('upcoming');

  return (
    <AppLayout>
      <Box sx={{ marginTop: { xs: 1, sm: 2 } }}>
        <Typography sx={{ fontSize: { xs: 24, sm: 28, md: 32 }, marginBottom: { xs: 1.5, sm: 2 }, fontWeight: 600 }}>
          Записи
        </Typography>

        {/* Bubble Toggle */}
        <Box sx={{
          display: 'flex',
          gap: { xs: '6px', sm: '8px' },
          mb: { xs: 1, sm: 2 },
          backgroundColor: '#F5F5F5',
          padding: { xs: '3px', sm: '4px' },
          borderRadius: '24px',
          width: 'fit-content',
          flexWrap: 'wrap',
        }}>
          <Button
            onClick={() => setTabValue('upcoming')}
            sx={{
              flex: 1,
              minWidth: { xs: '90px', sm: '110px', md: '130px' },
              height: { xs: '40px', sm: '45px', md: '50px' },
              borderRadius: '24px',
              textTransform: 'none',
              fontSize: { xs: '13px', sm: '15px', md: '16px' },
              fontWeight: 600,
              fontFamily: 'TikTok Sans, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
              backgroundColor: tabValue === 'upcoming' ? '#007AFF' : 'transparent',
              color: tabValue === 'upcoming' ? '#FFFFFF' : 'rgba(33, 33, 33, 0.7)',
              border: tabValue === 'upcoming' ? 'none' : '1px solid rgba(33, 33, 33, 0.3)',
              transition: 'all 0.2s ease',
              '&:hover': {
                backgroundColor: tabValue === 'upcoming' ? '#0055CC' : 'rgba(0, 122, 255, 0.1)',
              }
            }}
          >
            Активные
          </Button>
          <Button
            onClick={() => setTabValue('past')}
            sx={{
              flex: 1,
              minWidth: { xs: '95px', sm: '120px', md: '140px' },
              height: { xs: '40px', sm: '45px', md: '50px' },
              borderRadius: '24px',
              textTransform: 'none',
              fontSize: { xs: '13px', sm: '15px', md: '16px' },
              fontWeight: 600,
              fontFamily: 'TikTok Sans, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
              backgroundColor: tabValue === 'past' ? '#007AFF' : 'transparent',
              color: tabValue === 'past' ? '#FFFFFF' : 'rgba(33, 33, 33, 0.7)',
              border: tabValue === 'past' ? 'none' : '1px solid rgba(33, 33, 33, 0.3)',
              transition: 'all 0.2s ease',
              '&:hover': {
                backgroundColor: tabValue === 'past' ? '#0055CC' : 'rgba(0, 122, 255, 0.1)',
              }
            }}
          >
            Прошедшие
          </Button>
        </Box>

        {tabValue === 'upcoming' && <AppointmentsList type="upcoming" />}
        {tabValue === 'past' && <AppointmentsList type="past" />}
      </Box>
    </AppLayout>
  );
};
